__turbopack_context__.v({
  "loading": "ForumActivityCardsList-module-scss-module__5xKYMa__loading",
  "loadingMore": "ForumActivityCardsList-module-scss-module__5xKYMa__loadingMore",
  "root": "ForumActivityCardsList-module-scss-module__5xKYMa__root",
});
